import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const UserBoard: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="user board icon">
      {/* <title>user board icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.61452 4.67371C4.17095 3.3515 5.39122 2.52734 6.98894 2.52734H12.3241C13.4336 2.52734 14.3729 2.92255 15.0321 3.63061C15.6874 4.33448 16.0274 5.30532 16.0274 6.39302V10.9475C16.0274 12.0353 15.6874 13.0061 15.032 13.71C14.3726 14.4181 13.4332 14.8132 12.3234 14.8132H9.93271C9.64595 14.8132 9.41348 14.5807 9.41348 14.294C9.41348 14.0072 9.64595 13.7748 9.93271 13.7748H12.3234C13.1768 13.7748 13.8298 13.4772 14.272 13.0023C14.7181 12.5232 14.9889 11.8209 14.9889 10.9475V6.39302C14.9889 5.51972 14.7181 4.81733 14.272 4.33823C13.8299 3.86332 13.1771 3.56581 12.3241 3.56581H6.98894C5.78889 3.56581 4.95832 4.15777 4.57167 5.07652C4.46044 5.34083 4.156 5.46492 3.89169 5.35369C3.62737 5.24246 3.50329 4.93801 3.61452 4.67371Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5332 11.9952C10.5332 11.7084 10.7657 11.476 11.0524 11.476H12.6474C12.9343 11.476 13.1667 11.7084 13.1667 11.9952C13.1667 12.2819 12.9343 12.5144 12.6474 12.5144H11.0524C10.7657 12.5144 10.5332 12.2819 10.5332 11.9952Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.41037 12.2049C3.05435 11.989 3.8922 11.9276 4.73132 11.9276C5.57554 11.9276 6.41392 11.9915 7.05746 12.2104C7.38201 12.3207 7.69479 12.4828 7.93094 12.7303C8.17913 12.9904 8.32009 13.3222 8.32009 13.7088C8.32009 14.0963 8.17761 14.4282 7.92789 14.6873C7.6905 14.9335 7.37661 15.0939 7.05199 15.2027C6.40797 15.4186 5.57021 15.4802 4.73132 15.4802C3.88731 15.4802 3.04893 15.4166 2.40538 15.1981C2.08086 15.0879 1.76798 14.926 1.53172 14.6784C1.28348 14.4183 1.14258 14.0864 1.14258 13.6998C1.14258 13.3121 1.28477 12.9801 1.53445 12.7207C1.77182 12.4742 2.08572 12.3137 2.41037 12.2049ZM2.28253 13.441C2.21549 13.5106 2.18104 13.586 2.18104 13.6998C2.18104 13.8146 2.21576 13.8911 2.28295 13.9615C2.36213 14.0444 2.50451 14.1351 2.73929 14.2148C3.21434 14.3762 3.91072 14.4417 4.73132 14.4417C5.54807 14.4417 6.24507 14.378 6.72191 14.2181C6.95769 14.1391 7.10079 14.049 7.1802 13.9665C7.24735 13.897 7.28162 13.8219 7.28162 13.7088C7.28162 13.5942 7.24694 13.5177 7.17965 13.4472C7.10038 13.3642 6.9579 13.2734 6.72313 13.1936C6.2481 13.032 5.55173 12.9661 4.73132 12.9661C3.91406 12.9661 3.21715 13.0296 2.74048 13.1895C2.5048 13.2685 2.36188 13.3586 2.28253 13.441Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80538 7.47358C4.07346 7.47358 3.48036 8.06671 3.48036 8.79862C3.48036 9.53052 4.07346 10.1236 4.80538 10.1236C5.5373 10.1236 6.13041 9.53052 6.13041 8.79862C6.13041 8.06671 5.5373 7.47358 4.80538 7.47358ZM2.44189 8.79862C2.44189 7.49316 3.49993 6.43512 4.80538 6.43512C6.11083 6.43512 7.16887 7.49316 7.16887 8.79862C7.16887 10.104 6.11083 11.1621 4.80538 11.1621C3.49993 11.1621 2.44189 10.104 2.44189 8.79862Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default UserBoard;
